import React, {Component} from 'react';
import {IAuthStore} from '../../mobx-store/storeInterfaces/authStoreInterface';
import {inject, observer} from 'mobx-react';
import {translate} from '../../helperFunctions/translation';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import Directives from '../../components/Directives/Directives';
import styles from './login.module.sass';

interface IProps {
    authStore?: IAuthStore;
    history?: History;
}

interface State {
    email: string;
    password: string;
    error: any;
    showPassword: boolean;
}

@inject('authStore')
@observer
class Login extends Component<IProps, State> {

    state = {
        email: '',
        password: '',
        error: '',
        showPassword: false,
    };
    handleSubmit = (e: any) => {
        e.preventDefault();
        (this.props.authStore as any).login(this.state.email, this.state.password)
            .then((res: any) => {
                this.setState({error: null});
            }).catch(() => this.setState({error: translate('loginScreen.loginError', {})}));
    }
    handleChange = (prop: 'email' | 'password') => (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        this.setState({[prop]: event.target.value} as Pick<State, typeof prop>);
    }
    handleShowPassword = () => {
        this.setState(({showPassword: !this.state.showPassword}));
    }

    render() {
        return (
            <div className={styles.loginCard}>
                <div className={styles.loginCard}>
                    <Typography variant='h1' component='h1' className={styles.formTitle}>Student</Typography>
                    <form onSubmit={this.handleSubmit}>
                        <FormControl className={styles.formItem}>
                            <TextField
                                className={styles.inputField}
                                name='email'
                                value={this.state.email}
                                variant='outlined'
                                onChange={this.handleChange('email')}
                                type='text'
                                label={translate('loginScreen.email', {})}
                                InputProps={{
                                    startAdornment: <InputAdornment position='start'><AccountCircle/></InputAdornment>,
                                }}
                            />
                        </FormControl>
                        <FormControl className={styles.formItem}>
                            <TextField className={styles.inputField}
                                       label={translate('loginScreen.password', {})}
                                       name='password'
                                       variant='outlined'
                                       value={this.state.password}
                                       onChange={this.handleChange('password')}
                                       type={this.state.showPassword ? 'text' : 'password'}
                                       InputProps={{
                                           endAdornment: (
                                               <InputAdornment position='end'>
                                                   <IconButton
                                                       aria-label='Toggle password visibility'
                                                       onClick={this.handleShowPassword}
                                                   >
                                                       <Directives dIf={this.state.showPassword}>
                                                           <VisibilityOff/>
                                                       </Directives>
                                                       <Directives dIf={!this.state.showPassword}>
                                                           <Visibility/>
                                                       </Directives>
                                                   </IconButton>
                                               </InputAdornment>
                                           ),
                                       }}
                            />
                        </FormControl>
                        <Button className={styles.loginButton}
                                variant='contained'
                                type='submit'
                                color='primary'>
                            {translate('loginScreen.login', {})}
                        </Button>
                        {<p className={styles.error}>{this.state.error}</p>}
                    </form>

                </div>

            </div>
        );

    }
}

export default Login;
